import React from "react";
import { Controller } from "react-hook-form";

const YesNoField = ({ name, label, control, rules }) => {
  return (
    <div className="yes-no-field">
      <label className="yes-no-label">
        {label}
        {rules?.required && <span style={{ color: "red" }}> *</span>}
      </label>
      <div className="yes-no-options">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState: { error } }) => (
            <>
              <label>
                <input
                  {...field}
                  type="radio"
                  value="true"
                  checked={field.value === "true"}
                />
                Yes
              </label>
              <label>
                <input
                  {...field}
                  type="radio"
                  value="false"
                  checked={field.value === "false"}
                />
                No
              </label>
              {error && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {error.message || "This field is required"}
                </span>
              )}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default YesNoField;
